var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ns-filter",class:'filter-style-' + _vm.UID},[_c('style',{ref:"styleRef"}),_vm._v(" "),_vm._l((_vm.filters),function(filter,_index){return _c('div',{key:filter,staticClass:"ns-filter-button",class:{
      selected: _vm.index === _index,
    },attrs:{"index":_index},on:{"click":_vm.filterClick}},[_vm._v("\n    "+_vm._s(filter)+"\n  ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }